import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import { TransactionTypes } from '../../data/models/Transaction'

const refundsDetailsParserV3 = (data: any, txnType: string): any => {
  const refunds = data?.data?.data?.content

  const txn = refunds.map((txnItem: any) => ({
    rrn: txnType === TransactionTypes.Transaction ? txnItem?.transactionId : txnItem?.transactionId ?? '', //TODO: retrievalReferenceNumber is now transactionId - check transactionId mapping once data is coming
    trxAmount: txnItem?.transactionAmount ?? 0,
    refundAmount: txnItem?.refundAmount ?? 0,
    initiatedDate: dateFormatter(txnItem?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_ONLY),
    status: txnItem?.refundStatus ?? 'NA',
    processedOn: dateFormatter(txnItem?.refundProcessedDate ?? 'NA', DateFormatTypes.DATE_ONLY),
    currency: txnItem?.issCountryCode ?? 'NA',
    arn: txnItem?.externalReferenceNumber ?? 'NA',
  }))
  return txn
}

export { refundsDetailsParserV3 }
